import { render, staticRenderFns } from "./DashboardBase.vue?vue&type=template&id=5f008403"
import script from "./DashboardBase.vue?vue&type=script&lang=js"
export * from "./DashboardBase.vue?vue&type=script&lang=js"
import style0 from "./DashboardBase.vue?vue&type=style&index=0&id=5f008403&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports